export const LaborAmendCompletionProvenanceFailureReason = {
  MissingVersionId: "missing_version_id",
  MissingPractitioner: "missing_practitioner",
  MissingQuestionnaireResponseId: "missing_questionnaire_response_id",
  CreateFailed: "create_failed",
} as const;

export type LaborAmendCompletionProvenanceFailureReason =
  (typeof LaborAmendCompletionProvenanceFailureReason)[keyof typeof LaborAmendCompletionProvenanceFailureReason];

export const LABOR_AMEND_COMPLETION_PROVENANCE_CREATE_FAILED_MESSAGE =
  "Failed to create labor amend completion Provenance.";
